const storeConstants = {
	UPDATE_ACCOUNT_INFO: "Update Account Info",
	UPDATE_TYPE_ARRAY: "Update Type Array"
}

export default storeConstants;